import React from 'react';
import { connect } from 'react-redux';
import { Segment, Header } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import findResult from '@/utils/resultsHelper';
import fetch from '../hooks/fetch';
import DatasourceForm from '../components/DatasourceForm';
import {
  fetchDatasourceSettings,
  fetchDatasourceTypes,
  initialiseDatasourceSettings,
  updateDatasourceSettings,
} from '../actions';
import { newDatasourceSettings } from '../state/state';
import { supportedDatasourceTypes } from '../helper';

const SelectDatasourceType = ({
  category,
  code,
  compact,
  fetchData,
  fetchTypes,
  isNew,
  newData,
  readStatus,
  settings,
  supportedTypes,
  updateSettings,
}) => {
  const intl = useIntl();
  fetch.useFetchOrInitialiseDatasource(fetchData, fetchTypes, newData, category, code, readStatus, isNew);
  return (
    <Segment raised>
      <Header as="h4" icon="server" content={intl.formatMessage({ id: 'select.datasource.type.title' })} />
      <DatasourceForm
        compact={compact}
        readStatus={readStatus}
        settings={settings}
        supportedTypes={supportedTypes}
        updateSettings={(properties) => updateSettings(category, code, properties)}
      />
    </Segment>
  );
};

const mapStateToProps = ({
  datasetDatasource: { settings, datasources },
}, { category, code }) => {
  const item = findResult(settings, category, code) || newDatasourceSettings({ code });
  const supportedTypes = supportedDatasourceTypes(datasources.all.results, item);

  return ({
    readStatus: item.readStatus,
    settings: item.copy,
    supportedTypes,
  });
};

const mapDispatchToProps = {
  fetchData: fetchDatasourceSettings,
  fetchTypes: fetchDatasourceTypes,
  newData: initialiseDatasourceSettings,
  updateSettings: updateDatasourceSettings,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectDatasourceType);
